<template>
  <a-modal 
    :visible="hidden" 
    :title="title"
    :width="900"
    :forceRender="true"
    @ok="ok"
    @cancel="cancel"
    destroyOnClose
  >
    <a-row slot="footer" type="flex" justify="space-between" class="footer">
      <span>
        <span style="font-size:12px;">
        已选中 <span style="color: red;">{{selectLen}}</span> 个产品
        </span>
      </span>
      <a-space>
        <a-button @click="cancel">取消</a-button>
        <a-button @click="ok" type="primary">保存</a-button>
      </a-space>
    </a-row>
    <a-tabs v-model="selected">
      <a-tab-pane key="1" tab="产品库">
        <import-product-library ref="ImportProductLibrary" @selectLen="getSelectLen" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="工厂产品">
        <import-factory-products ref="ImportFactoryProducts" @selectLen="getSelectLen" />
      </a-tab-pane>
      <a-tab-pane key="3" tab="定制料产品">
        <import-customized-products ref="ImportCustomizedProducts" @selectLen="getSelectLen" />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>


<script>
import { nhfMixins } from "../../untils";
import ImportProductLibrary from './ImportProductLibrary'
import ImportFactoryProducts from './ImportFactoryProducts'
import ImportCustomizedProducts from './ImportCustomizedProducts'
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  props: ['hidden'],
  mixins: [nhfMixins],
  components: {ImportProductLibrary,ImportFactoryProducts,ImportCustomizedProducts},
  data(){
    return {
      title: '导入产品库',
      selected: '1',
      feildObj: {
        '1': 'ImportProductLibrary',
        '2': 'ImportFactoryProducts',
        '3': 'ImportCustomizedProducts',
      },
      formulaId: getRequest('id'),
      typeObj: {
        '1': '4',
        '2': '2',
        '3': '3'
      },
      selectLen: 0
    }
  },
  watch: {
    hidden(val){
      if(val) this.selected = '1'
    },
    selected(){
      this.changeTab()
    },
  },
  methods: {
    getSelectLen(selectLen){
      this.selectLen = selectLen
    },
    changeTab(){
      let componentsFeild = this.feildObj[this.selected] || 'ImportProductLibrary'
      let {selectedRows} = this.$refs[componentsFeild] || {}
      this.selectLen = selectedRows ? selectedRows.length : 0
    },
    async ok(){
      let {selectedRows} = this.$refs[this.feildObj[this.selected]]
      if(selectedRows.length === 0){
        this.$message.warning('请选择产品')
        return
      }
      let customFormulaRawProAddList = []
      selectedRows.forEach(el => {
        customFormulaRawProAddList.push({
          type: this.typeObj[this.selected],
          formulaId: el.formulaId,
          productId: this.selected == 1 ? el.productId : el.id
        })
      })
      // this.$emit('close',true)
      let data = {
        customFormulaRawProAddList,
        formulaId: this.formulaId,
        staffId: window.localStorage.getItem('staffId')
      }
      await this.fetchPost({
        actions: this.saveCustomFormulaRawProIds,
        data,
      });
      this.$emit('close',true)
    },
    cancel(){
      this.$emit('close')
    },
  }
}
</script>